import { render, staticRenderFns } from "./CertificateContent4.vue?vue&type=template&id=97f8508a&scoped=true&"
import script from "./CertificateContent4.vue?vue&type=script&lang=js&"
export * from "./CertificateContent4.vue?vue&type=script&lang=js&"
import style0 from "./CertificateContent4.vue?vue&type=style&index=0&id=97f8508a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97f8508a",
  null
  
)

export default component.exports